const TrainingUnionTypeTypenameEnum = {
  course: 'Course',
  path: 'Curriculum',
  curriculum: 'Curriculum',
  activity: 'Activity'
};

export { TrainingUnionTypeTypenameEnum };
export default TrainingUnionTypeTypenameEnum;
